"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectQuestionModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class MultiSelectQuestionModule extends base_1.SelectModule {
    constructor({ requiredMin, requiredMax, ...rest }) {
        super(rest);
        this._type = "MultipleSelectQuestion";
        this._requiredMin = requiredMin;
        this._requiredMax = requiredMax;
    }
    get requiredMin() {
        return this._requiredMin;
    }
    set requiredMin(requiredMin) {
        if (typeof requiredMin !== "number" || requiredMin <= 0) {
            throw new Error("requiredMin must be greater than 0");
        }
        this._requiredMin = requiredMin;
    }
    get requiredMax() {
        return this._requiredMax;
    }
    set requiredMax(requiredMax) {
        if (typeof requiredMax !== "number" || requiredMax <= 0) {
            throw new Error("requiredMax must be greater than 0");
        }
        this._requiredMax = requiredMax;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const userValues = [];
            const { requiredMax, requiredMin, ...base } = buildBaseModule(this, userValues);
            const builderConfigModule = {
                ...base,
                actionRequired: this.actionRequired,
            };
            if (typeof requiredMin === "number" && requiredMin >= 0) {
                builderConfigModule.requiredMin = this.requiredMin;
            }
            if (typeof requiredMax === "number" && requiredMax >= 0) {
                builderConfigModule.requiredMax = this.requiredMax;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        if (this.validate()) {
            const userValues = [];
            const { requiredMin, requiredMax, label, ...base } = buildBaseModule(this, userValues);
            const surveyConfigModule = {
                ...base,
                actionRequired: this.actionRequired,
                header: { children: (_a = label[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
                options: this.options.map((opt) => {
                    var _a;
                    const option = {
                        id: opt.id || (0, util_1.generateUUID)(),
                        label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    };
                    if (opt.userDefined) {
                        option.userDefined = true;
                    }
                    return option;
                }),
                noBorder: this.noBorder,
            };
            if (typeof requiredMin === "number" || typeof requiredMax === "number") {
                surveyConfigModule.validation = (0, util_1.addRequiredCountValidation)({
                    min: this.requiredMin,
                    max: this.requiredMax,
                });
            }
            if (userValues.length && surveyConfigModule.validation) {
                surveyConfigModule.validation.userValues = userValues;
            }
            return surveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        var _a;
        return {
            id: this.id,
            options: this.options.map((opt) => {
                var _a;
                return ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    userDefined: opt.userDefined,
                });
            }),
            type: this.type,
            question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
            actionRequired: this.actionRequired,
        };
    }
}
exports.MultiSelectQuestionModule = MultiSelectQuestionModule;
const buildBaseModule = (mod, userValues) => {
    const baseModule = {
        id: mod.id,
        label: mod.label,
        options: mod.options.map((opt) => {
            const option = {
                id: opt.id || (0, util_1.generateUUID)(),
                label: opt.label,
            };
            if (opt.userDefined) {
                userValues.push(opt.id || (0, util_1.generateUUID)());
                option.userDefined = true;
            }
            return option;
        }),
        requiredMax: mod.requiredMax,
        requiredMin: mod.requiredMin,
        type: mod.type,
    };
    if (mod.randomizeOptions) {
        baseModule.randomizeOptions = true;
    }
    return baseModule;
};
//# sourceMappingURL=MultiSelectQuestion.js.map